
import { SharedKanbanBoard } from "@/components/jobs/kanban/SharedKanbanBoard";

interface CandidateKanbanProps {
	candidateId: string;
}

export const CandidateKanban = ({ candidateId }: CandidateKanbanProps) => {
	return (
		<div className="w-full">
			<SharedKanbanBoard candidateId={candidateId} />
		</div>
	);
};
